import { Stack, Grid, Button, Group, ContentCard } from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon, BoltIcon, ChevronRightIcon } from '@forwardflow/icons'
import { motion } from 'framer-motion'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { StageMapGroup } from './stage-mapping/StageMapGroup'

export const StageMappingStopStages = () => {
   const { getPreviousStep, getNextStep } = useOnboardingStoreV2()

   const handleNextStep = () => {
      getNextStep()
   }

   return (
      <Stack gap={32}>
         <ContentCard
            className="space-y-2 !p-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
         >
            <Group>
               <Group className="p-2 px-2.5 rounded-[16.2px] border-[0.9px] border-[#8E51FF]/30 bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30">
                  <BoltIcon width={24} color="#9F7BFF" />
               </Group>
               <Stack gap={4}>
                  <p className="text-white font-medium">
                     When should Forward Flow stop contacting a lead?
                  </p>
                  <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
                     Choose the stages or tags that mean a lead shouldn't be
                     contacted anymore
                  </p>
               </Stack>
            </Group>
         </ContentCard>

         <StageMapGroup title="Under Contract" groupId="ff-under-contract" allowAddStage />

         <StageMapGroup
            title="Active Client Stages"
            description="When you start working with a client, Forward Flow should stop trying to set new appointments. Select the stage or tag that represents an active or in-progress client"
            groupId="ff-active-client"
            shouldAddDescription
            allowAddStage
         />

         <StageMapGroup title="Do Not Contact" groupId="ff-do-not-contact" />

         <StageMapGroup
            title="Has an Agent"
            isOptional
            groupId="ff-has-agent"
         />

         <StageMapGroup title="Closed" isOptional groupId="ff-closed-client" />

         <StageMapGroup
            title="Other Stop Criteria"
            description="Add any other stop stages you have where we should stop contacting your leads"
            groupId="ff-other-stop"
            allowAddStage
            shouldAddDescription
         />

         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Grid>
               <Grid.Col span={3}>
                  <Button
                     variant="secondary"
                     className="w-full"
                     onClick={() => getPreviousStep()}
                  >
                     <ArrowLeftMdIcon width={12} /> Back
                  </Button>
               </Grid.Col>
               <Grid.Col span={9}>
                  <Button className="w-full" onClick={() => handleNextStep()}>
                     Confirm stage mapping <ChevronRightIcon width={18} />
                  </Button>
               </Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
